import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'


const apiConst = {
  // 马甲包
  app_list: baseAPI + baseUrl + 'config/app/query',
  update_props: baseAPI + baseUrl + 'config/app/update_props',
  update_base: baseAPI + baseUrl + 'config/app/update_base',
  update_stream: baseAPI + baseUrl + 'config/app/update_stream',
  update_admin: baseAPI + baseUrl + 'config/app/update_admin',
  update_google_recharge: baseAPI + baseUrl + 'config/app/update_google_recharge',
  update_apple_login: baseAPI + baseUrl + 'config/app/update_apple_login',
  update_apple_recharge: baseAPI + baseUrl + 'config/app/update_apple_recharge',
  update_facebook_login: baseAPI + baseUrl + 'config/app/update_facebook_login',
  update_advertisement: baseAPI + baseUrl + 'config/app/update_advertieement',
  delete_advertisement: baseAPI + baseUrl + 'config/app/delete_advertieement',
  delete_app: baseAPI + baseUrl + 'config/app/delete',
  update_app_all: baseAPI + baseUrl + 'config/app/update_all',
  update_proxy: baseAPI + baseUrl + 'config/app/update_proxy',
  update_customer: baseAPI + baseUrl + 'config/app/update_customer_service',
}


// 马甲包查询
export const getAppList = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.app_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包更新属性
export const updateAppProps = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.update_props,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包更新基础
export const updateAppBase = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.update_base,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包更新音视频
export const updateAppStream = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.update_stream,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包更新admin操作
export const updateAppAdmin = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.update_admin,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包更新谷歌充值
export const updateGoogleRecharge = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.update_google_recharge,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包更新苹果登录
export const updateAppleLogin = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.update_apple_login,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包更新苹果充值
export const updateAppleRecharge = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.update_apple_recharge,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包更新facebook登录
export const updateFacebookLogin = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.update_facebook_login,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包更新广告
export const updateAdvertisement = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.update_advertisement,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包删除单个广告
export const deleteAdvertisement = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.delete_advertisement,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包删除
export const deleteApp = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.delete_app,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包更新全部
export const updateAppAll = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.update_app_all,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包更新代理
export const updateProxy = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.update_proxy,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 马甲包更新客服
export const updateCustomer = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.update_customer,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}